import _path from 'ramda/src/path';
import request from './AxiosRequest';

const verifyEmailGet = (data) =>
	request({
		url: '/services/api/useraccount/ResetEmailVerification',
		method: 'GET',
		data: data,
		cancel: true
	});

const verifyEmailPost = data =>
	request({
		url: '/services/api/useraccount/VerifyEmailAddress',
		method: 'GET',
		cancel: true,
		data: data
	});

const paymentEnroll = data =>
	request({
		url: '/services/api/useraccount/paymentenroll',
		method: 'POST',
		data: data,
		cancel: true
	});

const paymentAccount = () =>
	request({
		url: '/services/api/useraccount/paymentaccount',
		method: 'POST',
		cancel: true
	});

const verifyPin = data =>
	request({
		url: '/Services/API/Useraccount/VerifyPin',
		method: 'POST',
		data: data
	});

const getProfile = data =>
	request({
		url: `/services/api/useraccount/targetuserprofile`,
		method: 'GET',
		data: data,
		cancel: true
	});

const postAccountJson = data =>
	request({
		url: '/Services/api/useraccount',
		method: 'POST',
		data
	});

const getAccountJson = uid =>
	request({
		url: `/Services/api/useraccount?userId=${uid}`,
		method: 'GET',
		cancel: true
	});

const postAccountJsonMerged = data => {
	const userid = _path(['RESAAS', 'User2', 'UserId'], window);
	return getAccountJson(userid).request.then(response => {
		const newdata = { ...response.data, ...data };
		return postAccountJson(newdata);
	});
};

const createPin = data =>
	request({
		url: '/Services/API/Useraccount/CreatePin',
		method: 'POST',
		data
	});

const getPin = () =>
	request({
		url: '/Services/API/Useraccount/GetPin',
		method: 'GET',
		cancel: true
	});

const verifyReset = data =>
	request({
		url: '/Services/api/useraccount/VerifyReset',
		method: 'POST',
		data
	});

const updatePin = data =>
	request({
		url: '/Services/api/useraccount/UpdatePin',
		method: 'POST',
		data
	});

const resetPinRequest = () =>
	request({
		url: '/Services/API/Useraccount/resetPinRequest',
		method: 'POST'
	});

const UserAccount = {
	verifyEmailGet,
	verifyEmailPost,
	paymentEnroll,
	paymentAccount,
	getProfile,
	postAccountJson,
	getAccountJson,
	postAccountJsonMerged,
	createPin,
	getPin,
	verifyPin,
	verifyReset,
	updatePin,
	resetPinRequest
};

export default UserAccount;
